<script>

    export let post = {};

</script> 

<div class="post">
    {@html post.html}
</div>

<style>

    .post {
        margin-bottom: 1rem;
    }

</style>